import { EntityUtils } from '@record-it-npm/synchro-client';
import React, { ComponentProps, FunctionComponent } from 'react';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { WorkTimeEntry } from '../../../classes/entities/WorkTimeEntry/workTimeEntryTypes';
import { WorkTimeEntryListItem } from '../WorkTimeEntryListItem/WorkTimeEntryListItem';

export type WorkTimeEntryListProps = PropsWithoutChildren<
  ComponentProps<'div'>
> & {
  workTimeEntries: Array<WorkTimeEntry>;
};

export const WorkTimeEntryList: FunctionComponent<WorkTimeEntryListProps> =
  React.memo((props) => {
    const { workTimeEntries, ...remainingProps } = prepareProps({
      props,
      ignoreChildren: true
    });

    return (
      <div {...remainingProps}>
        {workTimeEntries.map((wte) => (
          <WorkTimeEntryListItem
            key={EntityUtils.getTrackingKey(wte)}
            workTimeEntry={wte}
            data-testid="WorkTimeEntryList.ListItem"
          ></WorkTimeEntryListItem>
        ))}
      </div>
    );
  });
